import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [ { image: require('../../../assets/images/person_7.jpg'), text: 'Nest Auto Transport made my car shipping experience completely stress-free! From booking to delivery, everything was smooth. Highly recommended!', name: 'Michael Johnson' }, { image: require('../../../assets/images/person_3.jpg'), text: 'I was worried about transporting my luxury car across states, but Nest Transport handled it with great care. Their enclosed transport option gave me peace of mind!', name: 'Sarah Williams' }, { image: require('../../../assets/images/noimage.png'), text: 'As part of my military relocation, I needed a reliable auto transport service. NEST Auto delivered my car safely and ahead of schedule. A+ service!', name: 'David Thompson' }, { image: require('../../../assets/images/person_8.jpg'), text: 'Moving to a new city for college was overwhelming, but NEST Auto made sure my car arrived safely. Their team kept me updated throughout the process!', name: 'Emily Davis' }, { image: require('../../../assets/images/noimage.png'), text: 'I run a small dealership and needed multiple vehicles shipped. NEST Auto Transport provided excellent service, on-time delivery, and competitive pricing!', name: 'Robert Martinez' }, { image: require('../../../assets/images/person_1.jpg'), text: 'I travel frequently and often need my car shipped to different locations. NEST company has been my go-to for reliable, safe, and affordable transport. Satisfied.', name: 'Jessica Lee' }, { image: require('../../../assets/images/person_2.jpg'), text: 'They exceeded my expectations. The communication was excellent, and my SUV arrived earlier than promised. Truly professional service! recommended.', name: 'Anthony Rogers' }, { image: require('../../../assets/images/noimage.png'), text: 'This was my first time shipping a vehicle, and this company made it incredibly easy. Their team explained everything clearly. I felt confident from start to finish!', name: 'Laura Mitchell' }, { image: require('../../../assets/images/person_4.jpg'), text: 'I needed my car transported across the country, and NEST handled it with care. The driver was polite and kept me updated throughout the journey!', name: 'Brandon Stewart' }, { image: require('../../../assets/images/noimage.png'), text: 'What I loved most was their transparency—no hidden fees and no last-minute surprises. NEST Transport is a company you can trust! recommended.', name: 'Olivia Parker' }, { image: require('../../../assets/images/person_6.jpg'), text: 'I had a tight schedule, but NEST Auto Transport managed everything perfectly. My car was picked up and delivered right on time. Excellent experience!', name: 'Christopher Adams' }, { image: require('../../../assets/images/person_9.jpg'), text: 'Highly professional team! I\'ve shipped cars with other companies before, but this transport company has been the most reliable by far. Will definitely use again.', name: 'Yousaf' } ];
  
   /**
   * ✅ SAFETY LOGIC
   * Swiper loop requires: slides >= slidesPerView + 1
   * We ensure that by duplicating when testimonials are few
   */
  const MIN_SLIDES_FOR_LOOP = 4;
  const slides =
    testimonials.length < MIN_SLIDES_FOR_LOOP
      ? [...testimonials, ...testimonials]
      : testimonials;

  return (
    <section className="ftco-section testimony-section">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-md-7 text-center heading-section">
            <span className="subheading">Testimonial</span>
            <h2 className="mb-3">Happy Clients</h2>
          </div>
        </div>

        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false
          }}
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={3}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            991: { slidesPerView: 3 }
          }}
        >
          {slides.map((t, index) => (
            <SwiperSlide key={index}>
              <div className="testimony-wrap text-center py-4 pb-5">
                <div
                  className="user-img mb-4 testimonial-image"
                  style={{ backgroundImage: `url(${t.image})` }}
                />
                <div className="text pt-4">
                  <p className="mb-4">{t.text}</p>
                  <p className="name">{t.name}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;